import React from 'react';
import { IconContainer } from './IconContainer';

const ExplainIcon = (props) => {
    return (
        <IconContainer color="var(--sp-error-hover-color)" ariaLabel="explain" { ...props }>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path fill="none" d="M0 0h24v24H0z"/>
                <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM11 7h2v2h-2V7zm0 4h2v6h-2v-6z" fill="currentColor" />
            </svg>
        </IconContainer>
    )
}

export { ExplainIcon };
